import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditApplication} from "../types/ICreditApplication";

const applicationLink = apiPath.credit.application.create;

export const postCalculatorApplications = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postCreditApplication: build.mutation<unknown, ICreditApplication>({
            query: (params) => ({
                url: applicationLink,
                method: "POST",
                body: params
            })
        })
    })
});

export const {usePostCreditApplicationMutation} = postCalculatorApplications;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {ICreditApplication} from "../types/ICreditApplication";

const applicationLink = apiPath.credit.application.create;

export const postCalculatorApplications = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postCreditApplication: build.mutation<unknown, ICreditApplication>({
            query: (params) => ({
                url: applicationLink,
                method: "POST",
                body: params
            })
        })
    })
});

export const {usePostCreditApplicationMutation} = postCalculatorApplications;
